module.exports = __webpack_public_path__ + "img/app-icon.2193f311.png";